export default "__VITE_ASSET__MzH2M58b__"